export const SET_THEME = "SET_THEME";
export const SET_LANGUAGE = "SET_LANGUAGE";

export const SET_BEFORE_INSTALL_EVENT = "SET_BEFORE_INSTALL_EVENT";

export interface SetTheme {
  type: typeof SET_THEME;
  payload: {
    theme: string;
  };
}
export interface SetLanguage {
  type: typeof SET_LANGUAGE;
  payload: {
    language: string;
  };
}

export interface SetBeforeInstallEvent {
  type: typeof SET_BEFORE_INSTALL_EVENT;
  payload: {
    beforeInstallEvent?: Event;
  };
}

export type GeneralDispatchType =
  | SetTheme
  | SetLanguage
  | SetBeforeInstallEvent;
